// src/features/legacy-reports/useLegacyReportsEligibility.ts

import { useAuth } from '@/features/auth/hooks/useAuth';
import { FEATURE_FLAGS } from '@/lib/constants/featureFlags';
import { resolveLegacyReportsEligibility } from './eligibility';

export interface LegacyReportsEligibility {
  eligible: boolean;
}

/**
 * THE single seam for Legacy Reports visibility (ADR-003 §12). Resolution:
 * build flag AND serviceRead permission AND the server-driven pre-`T` cohort
 * verdict — `legacyReportsEligible` on /customer/customerinfo, computed
 * server-side (top-level account created before T; children inherit the
 * top-level cohort — see ref_analytics_product_transition.md). Older gateways
 * omit the field; absent resolves eligible, mirroring the server's fail-open
 * rule. The verdict is read from the auth context's existing customer-info
 * query (fetched once for the login account) — valid for any selected
 * account because eligibility is uniform across a customer tree. Do NOT add
 * a client-side cohort heuristic (no date math here); the server remains the
 * authority and also rejects ineligible cohorts on /v1/reports1.
 *
 * Both the AppShell nav entry and the route component consume this hook.
 */
export function useLegacyReportsEligibility(): LegacyReportsEligibility {
  const { authData, customerInfo } = useAuth();
  return {
    eligible: resolveLegacyReportsEligibility({
      flagEnabled: FEATURE_FLAGS.legacyReportsEnabled,
      serviceRead: !!authData?.cpuser.permissions.serviceRead,
      serverEligible: customerInfo?.legacyReportsEligible,
    }),
  };
}
